// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__11Lpr","itemTitle":"ClientEmergencyInfo_itemTitle__v673-","itemText":"ClientEmergencyInfo_itemText__2Aco7"};